import * as z from "zod";

export const setCommerceCloudCartProduct = {
  name: "setCommerceCloudCartProduct" as const,
  input: z.object({ productId: z.string().min(1) }),
  output: z.null(),
};
